export const gallery = {
  productTypes: {
    filterBags: 'Filter Bags',
    filterCartridges: 'Filter Cartridges',
    filterBagHousings: 'Filter Bag Housings',
    filterCartridgeHousings: 'Filter Cartridge Housings',
    filterSheets: 'Filter Sheets',
    filterPress: 'Filter Press',
    filtrationEquipment: 'Filtration Equipment & Systems',
    filterAids: 'Filter Aids',
    beerFiltration: 'Beer Filtration Filters',
    microbiologicalMedia: 'Microbiological Media',
    other: 'Other',
  },
  hero: {
    title: 'Product Gallery',
    subtitle: 'Explore our comprehensive range of industrial filtration products and solutions from world-leading technology partners',
  },
  filters: {
    allPartners: 'All Partners',
    allProductTypes: 'All Product Types',
    searchPlaceholder: 'Search products, categories, specifications...',
    clear: 'Clear',
    resultsFound: 'product found',
    resultsFoundPlural: 'products found',
  },
  noResults: {
    title: 'No products found',
    description: 'Try adjusting your search or filters to find what you\'re looking for.',
    clearFilters: 'Clear Filters',
  },
  cta: {
    title: 'Need Help Choosing the Right Product?',
    subtitle: 'Our technical experts are ready to assist you in selecting the perfect filtration solution for your specific application',
    contactExperts: 'Contact Our Experts',
    requestStudy: 'Request a Study',
  },
};